// 应用入口
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';

// 按需注册 Vant 组件与函数式 API（Toast/Dialog）
import '@/utils/vant.js';
// 桌面端鼠标事件适配（Vant 移动端组件默认只监听 touch 事件）
import '@vant/touch-emulator';
// 全局基础样式
import '@/assets/reset.css';

Vue.config.productionTip = false;

new Vue({
    router,
    store,
    render: (h) => h(App),
}).$mount('#app');
